(function () {
  'use strict';
  function mount() {
    document.querySelectorAll('[data-answer-sharing]').forEach(container => {
      const button = container.querySelector('[data-share-answer]');
      if (!button || button.dataset.mounted) return;
      const canonical = document.querySelector('link[rel="canonical"]')?.href;
      if (!canonical) return;
      button.dataset.mounted = 'true';
      button.hidden = false;
      const status = container.querySelector('[data-answer-share-status]');
      const field = container.querySelector('[data-answer-share-link]');
      button.addEventListener('click', async () => {
        button.disabled = true;
        status.textContent = '';
        field.hidden = true;
        const payload = {title: document.querySelector('.wbf-answer-article h1').textContent, url: canonical};
        try {
          if (typeof navigator.share === 'function') {
            await navigator.share(payload);
            status.textContent = 'Answer ready to share.';
          } else if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(canonical);
            status.textContent = 'Link copied.';
          } else {
            throw new Error('Sharing unavailable');
          }
        } catch (error) {
          if (error.name !== 'AbortError') {
            field.hidden = false;
            field.value = canonical;
            field.focus();
            field.select();
            status.textContent = 'Copy this link to share the answer.';
          }
        } finally {
          button.disabled = false;
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
}());
